
var ViewFactory = require('tplify/dist/viewFactory').default;

delete module.exports;

var viewFactory = new ViewFactory('<div style="padding: 1.5rem 1.5rem 0 1.5rem">\n    <img class="signaturePresenter-signature" data-name="image">\n    <h2 class="signaturePresenter-name" data-property="name">Name</h2>\n</div>\n');

Object.defineProperty(module, 'exports', {
get: function() {
    return viewFactory.create();
}
});
